import React, { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import '../css/client.css';

import client1 from '../img/terragoldclientlogo1.jpg';
import client2 from '../img/terragoldclientlogo2.jpg';
import client3 from '../img/terragoldclientlogo3.jpg';

import client5 from '../img/terragoldclientlogo4.jpg';
import clinet6 from "../img/terragoldclientlogo6.jpg";
import client7 from '../img/terragoldclientlogo7.jpg'



import client10 from '../img/terragoldclientlogo5.jpg';

const clients = [
 { img: client1, title: "Paras Traders" },
{ img: client2, title: "Bavadekar Masala"},
{ img: client3, title: "Mangaram Trading Company" },
{ img: client5, title: "Foodelix General Manufacturing"},
{ img: clinet6, title: "Hari Om Namkeens" },
{ img: client7, title: "Mahaveer Traders" },
];

function Client() {


  return (
    <div className="container-fluid py-5">
        <div className="text-center mb-3">
            <h2 className="fw-bold display-6 text-gradient">
              <span className="position-relative" style={{color:'rgb(2, 58, 58)'}}>
           Our Clients
                <span className="position-absolute bottom-0 start-50 translate-middle-x bg-primary" 
                  style={{ 
                    height: '4px', 
                    width: '80px', 
                    borderRadius: '2px'
                  }}></span>
              </span>
            </h2>
          </div>
          <br></br>
     
      <Swiper
        loop={true}
        speed={3000}
        spaceBetween={30}
        autoplay={{ delay: 0, disableOnInteraction: false }}
        breakpoints={{
          0: { slidesPerView: 2 },
          576: { slidesPerView: 2 },
          768: { slidesPerView: 2 },
          992: { slidesPerView: 4 },
          1200: { slidesPerView: 5 },
        }}
        modules={[Autoplay]}
        className="client-swiper"
      >
        {clients.map((client, index) => (
          <SwiperSlide key={index}>
            <div className="text-center">
              <img
                src={client.img}
                alt={client.title}
                className="img-fluid mb-2"
                style={{ maxHeight: '100px', objectFit: 'contain' }}
              />
              <h6 className="mb-1">{client.title}</h6>
              <p className="text-muted small">{client.project}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

    </div>
  );
}

export default Client;
